import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {assert} from 'Asserts';
import {DataModificationsHeader} from 'audit/DataModifications';
import {patchJSONPromise} from 'util/Net';

export interface TreatmentGroupREST {
  id: string | null;
  name: string;
  label: string;
  description: string | null;
  targetNumberOfSubjects: number;
}

export interface SampleDefinitionREST {
  id: string | null;
  label: string;
  allowsNewSubjects: boolean;
  sampleTypeId: string;
  treatmentGroupLabel: string;
  visit: string;
}

export interface SampleTestPlanREST {
  id: string | null;
  sampleDefinitionLabel: string;
  procedureId: string;
}
export interface UpdateTrialSampleTestingStudyDesignParams {
  startDate: string | null;
  endDate: string | null;
  treatmentGroups: Array<TreatmentGroupREST>;
  sampleDefinitions: Array<SampleDefinitionREST>;
  sampleTestPlans: Array<SampleTestPlanREST>;
}

export interface UpdateTrialSampleTestingStudyDesignResponse {
  studyDesignId: string;
}

export async function updateTrialSampleTestingStudyDesign(
  studyDesignId: string,
  previousModifiedAt: string,
  updateTrialSampleTestingStudyDesignParams: Partial<UpdateTrialSampleTestingStudyDesignParams>,
  dataModsHeader?: DataModificationsHeader
): Promise<UpdateTrialSampleTestingStudyDesignResponse> {
  const response = await patchJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.TRIAL_SAMPLE_TESTING_STUDY_DESIGN),
    data: {updates: [{id: studyDesignId, previousModifiedAt, ...updateTrialSampleTestingStudyDesignParams}]},
    extraHeaders: dataModsHeader,
  });
  assert(response.updatedIds.length === 1, 'Expected one study design to be updated');
  assert(
    response.updatedIds[0] === studyDesignId,
    'Expected updated study design to have the same id as the input study design'
  );
  return {studyDesignId};
}
